/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/InputCaption/theme';

export const InputCaptionTheme = theme;
